import { useState, useRef } from "react";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function UploadImageToPostModal({ id, cancelModal }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const { user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef();

  const fileUploadHandler = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;

    setIsLoading(true);

    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/image/ClubPost/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setUploadSuccess(true);
        setSelectedFile(null);
        setPreviewUrl(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    if (file) {
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(null);
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  if (uploadSuccess) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Image Uploaded</p>
          </div>
          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <p>Would you like to add another image?</p>
          <div className="send-modal-footer">
            <button
              className="saveChanges-button mx-3"
              onClick={() => setUploadSuccess(false)}
            >
              Yes
            </button>
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              No
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div className="send-modal-content">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Upload Image</p>
          </div>
          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <div>
            <input type="file" onChange={handleFileChange} ref={fileInputRef} />
            <button
              className="saveChanges-button"
              onClick={fileUploadHandler}
              disabled={!selectedFile}
            >
              Upload
            </button>
          </div>
          {previewUrl && (
            <img
              src={previewUrl}
              alt="Image Preview"
              style={{ width: "100px", height: "100px" }}
            />
          )}
        </div>
        <div className="send-modal-footer">
          <button
            onClick={cancelModal}
            className="pointer cancelButton fw-bold mx-2 px-3"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
